import React from 'react';
import { Paper, Divider } from 'material-ui';
import PageBase from '../../../widgets/PageBase/PageBase';
import CategoryTemplate from '../../../widgets/MRS/CategoryTemplate';
import { formatNumber } from '../../../../utils/format-number-util';
import ReviewItemRow from '../../../widgets/MRS/ReviewItemRow';
import { getFillItemDescById, getFillItemNameById, itemSortMap } from '../../../../utils/mrs-util';

const ReviewMRSPage = (props) => {
  const getTotal = () => {
    return props.items.reduce((total, lineItem) => {
      return total + lineItem.adjustedPrice.priceItem * lineItem.quantity;
    }, 0);
  };

  const getItemRate = (item) => {
    if (item.itemCategory == 'CE') {
      return item.adjustedPrice.priceRental;
    }
    return item.adjustedPrice.priceItem;
  };

  // Sort the items by description
  const sortedItems = props.items
    .sort((a, b) =>
      a.subCategorySort - b.subCategorySort
      || getFillItemDescById(a, props.items).localeCompare(getFillItemDescById(b, props.items))
      || itemSortMap[a.itemCategory] - itemSortMap[b.itemCategory]
      || a.description.localeCompare(b.description)
    );

  return (
    <div>
      <PageBase navigation={['MRS']} includeInactiveBranches>
        <CategoryTemplate
          categoryName="MRS Summary"
          customer={props.customer}
          handleNext={props.handleSubmit}
          handleBack={props.handleBackCategory}
          backLabel="Back"
          nextLabel="Order"
        >
          <div style={{ textAlign: 'center', marginBottom: 10 }}>
            <h4>Total: ${formatNumber(getTotal(), 2)}</h4>
          </div>
          <Paper>
            {sortedItems.map((item, index, array) => {
              const lastElement = index == array.length - 1;
              return (
                <React.Fragment key={item.id}>
                  <ReviewItemRow
                    item={item}
                    qty={item.quantity}
                    frequency={item.frequency}
                    rate={getItemRate(item)}
                    owGroup={getFillItemNameById(item, props.items)}
                  />
                  {!lastElement ? <Divider /> : null}
                </React.Fragment>
              );
            })}
          </Paper>
        </CategoryTemplate>
      </PageBase>
    </div>
  );
};

export default ReviewMRSPage;
